import cx from 'clsx';

import { InputOverrideClassNames } from '../textinput';
import { InputStyleProps } from '../types';

import YearPickerInputClasses from './YearPickerInput.module.css';

export const YearPickerInputOverrideClassNames = (props: InputStyleProps) => {
  const dateInputClasses = InputOverrideClassNames(props);
  return {
    ...InputOverrideClassNames(props),
    input: cx(dateInputClasses.input, YearPickerInputClasses.input),
    yearsListControl: YearPickerInputClasses.yearsListControl,
    calendarHeaderLevel: YearPickerInputClasses.calendarHeaderLevel,
    calendarHeaderControl: YearPickerInputClasses.calendarHeaderControl
  };
};
